export class AlterarSenhaMultiplasContasRequestEntity {
  usuario: string;
  senha: string;
  confirmacaoSenha: string;
  usuariosEncrypt: string[] = [];
}
